import { jsxs, jsx } from 'react/jsx-runtime';
import { PermissionRole } from '@fabric/woody-client';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import Select from '@fabric-app/ui/components/Select';
import { cssVar } from '@fabric-app/ui/theme/variables';

const roleDisplayValue = {
  commenter: "can comment",
  editor: "can edit",
  viewer: "can view",
  owner: "owner"
};
const options = [
  {
    id: PermissionRole.VIEWER,
    label: roleDisplayValue["viewer"]
  },
  {
    id: PermissionRole.COMMENTER,
    label: roleDisplayValue["commenter"]
  },
  {
    id: PermissionRole.EDITOR,
    label: roleDisplayValue["editor"]
  }
];
const SelectPermissionRole = ({ value, onChange, onRemove, children, isLoading, canGrantPermissions, disabled, ["data-testid"]: dataTestId }) => {
  const { isMobileView } = useResponsive();
  return /* @__PURE__ */ jsxs(Select, {
    value,
    onChange,
    triggerProps: {
      variant: "bg-secondary",
      size: isMobileView ? "mobile-default" : "sm+",
      style: {
        ...!isMobileView && {
          fontSize: "0.8125rem"
        },
        fontWeight: 500,
        color: `rgba(${cssVar["color-text-primary-rgb"]}, 0.6)`
      },
      isLoading,
      disabled: canGrantPermissions === null || canGrantPermissions.length === 0 || disabled,
      ...{
        ["data-testid"]: dataTestId
      }
    },
    children: [
      options.map((option) => /* @__PURE__ */ jsx(Select.ItemOption, {
        value: option.id,
        disabled: !canGrantPermissions?.find((item) => item === option.id),
        "data-testid": `select-role-${option.id}`,
        children: option.label
      }, option.id)),
      onRemove && /* @__PURE__ */ jsx(Select.ItemOption, {
        onClick: (e) => {
          e.stopPropagation();
          e.preventDefault();
          onRemove();
        },
        value: "remove",
        children: "remove"
      }),
      children
    ]
  });
};

export { SelectPermissionRole, roleDisplayValue };
//# sourceMappingURL=SelectPermissionRole.js.map
